import { type ReactElement, type SVGProps } from 'react';

export const ArrowLeftIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.05324 11.4988L10.316 6.74735L9.64762 6L3.00195 12L9.64762 18L10.316 17.2526L5.05583 12.5036H21V11.4988H5.05324Z"
        fill="currentColor"
      />
    </svg>
  );
};
